
import { useTranslation } from "react-i18next";
import { InputControllerType1 } from "./controller/InputControllerType1";
import React from "react";
import CSSClassSerivce from "../../../services/CommonCSSSerivce";

interface IProps {
  type: TypeButton; 
  testId?:string;
  label?: string;
  classNameBaseFrame?: string;
  classNameFrame?: string;
  classNameInput: string;
  disabledAddClass?: string
  onIsDisabledClick?: () => void;
  onClick: (e : any) => void;
  disabled?: boolean | undefined;
  caption: () => React.ReactNode;
}

const ButtonType1: React.FC<IProps> = (props) => {

  const { t } = useTranslation();
  const c = InputControllerType1<string>({
    value: "",
    disabled: props.disabled,
    classNameFrame: props.classNameFrame,
    classNameInput: props.classNameInput,
    disabledClass: props.disabledAddClass ? props.disabledAddClass : ""
  })

    return (
      <div className={props.classNameBaseFrame} > 
        {(props.label != undefined)?
          <label htmlFor={props.label} className={CSSClassSerivce.labelClass}>{t(props.label ? props.label : "")}</label>:<></>
        }
        <div ref={c.setRefFrame}>
          <button 
            ref={(it) => {c.setRefInput(it)}}
            data-testid={props.testId}
            type={props.type}
            className={props.classNameInput}
            onMouseOver={() => {
              (props.onIsDisabledClick) ? props.onIsDisabledClick() : null
              //(props.disabled) ? props.onIsDisabledClick ? props.onIsDisabledClick() : null : null }
            }}
            onClick={(e: any) => { props.onClick(e) }
          }
          >
            {props.caption()}
          </button>
        </div>

      </div>
    );
};

export default ButtonType1;